import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { RectShape, TextBlock } from '@thd-olt-component-react/loading-placeholder';

export const ProductPodPlaceholder = ({ podsCount }) => (
  <Row className="placeholder-list show-loading-animation">
    { [...Array(podsCount)].map((n, i) => (
      <Col className="placeholder-product-pod" key={`placholder-${i}`} lg="3" md="3" sm="3" xs="4">
        <RectShape style={{ width: '100%', height: '250px', marginBottom: '10px' }} color="#E0E0E0" />
        <TextBlock rows={7} color="#E0E0E0" />
      </Col>
    ))}
  </Row>
);

ProductPodPlaceholder.propTypes = {
  podsCount: PropTypes.number
};

ProductPodPlaceholder.defaultProps = {
  podsCount: 8
};
